(function () {
  'use strict';

  // ─── Config ────────────────────────────────────────────────────────────────
  const TILE      = 25;
  const DURATION  = 300;
  const SCALE     = 0.008;
  const EDGE_SOFT = 0.15;

  // ─── Perlin Noise 2D ───────────────────────────────────────────────────────
  class Perlin {
    constructor() {
      const p = Array.from({ length: 256 }, (_, i) => i);
      for (let i = 255; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [p[i], p[j]] = [p[j], p[i]];
      }
      this.p = [...p, ...p];
    }
    fade(t) { return t * t * t * (t * (t * 6 - 15) + 10); }
    lerp(a, b, t) { return a + t * (b - a); }
    grad(h, x, y) {
      h &= 3;
      return ((h < 2 ? x : y) * (h & 1 ? -1 : 1)) +
             ((h < 2 ? y : x) * (h & 2 ? -1 : 1));
    }
    noise(x, y) {
      const X = Math.floor(x) & 255;
      const Y = Math.floor(y) & 255;
      x -= Math.floor(x); y -= Math.floor(y);
      const u = this.fade(x), v = this.fade(y);
      const a = this.p[X] + Y, b = this.p[X + 1] + Y;
      return this.lerp(
        this.lerp(this.grad(this.p[a],     x,     y),
                  this.grad(this.p[b],     x - 1, y),     u),
        this.lerp(this.grad(this.p[a + 1], x,     y - 1),
                  this.grad(this.p[b + 1], x - 1, y - 1), u),
        v
      );
    }
    fbm(x, y, octaves = 4) {
      let val = 0, amp = 0.5, freq = 1, max = 0;
      for (let i = 0; i < octaves; i++) {
        val += this.noise(x * freq, y * freq) * amp;
        max += amp; amp *= 0.5; freq *= 2.1;
      }
      return val / max;
    }
  }

  // ─── Canvas (injecté via le snippet liquid) ───────────────────────────────
  const canvas = document.getElementById('sll-transition-overlay');

  const ctx    = canvas.getContext('2d');
  const perlin = new Perlin();
  let tiles    = [];
  let animId   = null;

  function resizeCanvas() {
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function buildTiles() {
    tiles = [];
    const cols = Math.ceil(canvas.width  / TILE);
    const rows = Math.ceil(canvas.height / TILE);
    let min = Infinity, max = -Infinity;
    const raw = [];

    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const n = perlin.fbm(c * SCALE, r * SCALE);
        raw.push({ c, r, n });
        if (n < min) min = n;
        if (n > max) max = n;
      }
    }

    const range  = max - min;
    const mapped = 1 - 2 * EDGE_SOFT;
    for (const t of raw) {
      tiles.push({ c: t.c, r: t.r, threshold: ((t.n - min) / range) * mapped });
    }
  }

  function renderFrame(progress) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (const tile of tiles) {
      const delta = progress - tile.threshold;
      let alpha;
      if      (delta < -EDGE_SOFT) { alpha = 1; }
      else if (delta <  EDGE_SOFT) { alpha = 1 - (delta + EDGE_SOFT) / (2 * EDGE_SOFT); }
      else                         { continue; }
      ctx.fillStyle = `rgba(0,0,0,${alpha.toFixed(3)})`;
      ctx.fillRect(tile.c * TILE, tile.r * TILE, TILE, TILE);
    }
  }

  // ─── Intro : noir → transparent ────────────────────────────────────────────
  function playIntro() {
    if (animId) cancelAnimationFrame(animId);
    canvas.style.pointerEvents = 'none';
    canvas.classList.remove('black');
    resizeCanvas();
    buildTiles();
    let startTime = null;

    (function loop(ts) {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / DURATION, 1);
      renderFrame(progress);
      animId = progress < 1 ? requestAnimationFrame(loop) : null;
    })(performance.now());
  }

  // ─── Outro : transparent → noir, puis navigation ───────────────────────────
  function playOutro(url, openNewTab) {
    if (animId) cancelAnimationFrame(animId);
    canvas.style.pointerEvents = 'all'; // bloque les clics
    let startTime = null;

    (function loop(ts) {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / DURATION, 1);
      renderFrame(1 - progress); // sens inverse
      if (progress < 1) {
        animId = requestAnimationFrame(loop);
      } else {
        // Garantir un noir total avant de naviguer
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        setTimeout(() => {
          if (openNewTab) {
            window.open(url, '_blank');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            canvas.style.pointerEvents = 'none';
          } else {
            window.location.href = url;
          }
        }, 150);
      }
    })(performance.now());
  }

  // ─── Interception des liens ────────────────────────────────────────────────
  function isInternal(url) {
    try {
      const u = new URL(url, window.location.href);
      return u.hostname === window.location.hostname;
    } catch { return false; }
  }

  function shouldSkip(href) {
    if (!href) return true;
    if (href.startsWith('#')) return true;           // ancre
    if (href.startsWith('mailto:')) return true;
    if (href.startsWith('tel:')) return true;
    if (href.startsWith('javascript:')) return true;
    return false;
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (shouldSkip(href)) return;
    if (!isInternal(link.href)) return;

    // Laisser passer les clics avec modificateurs (ctrl/cmd/shift = nouvel onglet)
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.target === '_blank') return;

    e.preventDefault();
    playOutro(link.href, false);
  }, true);

  // ─── Lancement ─────────────────────────────────────────────────────────────
  const MIN_DURATION = 300;  // durée minimale de l'intro
  const MAX_DURATION = 800;  // cap absolu — on lève quoi qu'il arrive

  resizeCanvas();
  buildTiles();

  // Remplir noir immédiatement
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  canvas.style.pointerEvents = 'none';

  // Triple verrou : min 400ms + window.load + cap 800ms
  const startAt = performance.now();

  const minDelay    = new Promise(res => setTimeout(res, MIN_DURATION));
  const pageLoaded  = new Promise(res => {
    if (document.readyState === 'complete') res();
    else window.addEventListener('load', res, { once: true });
  });
  const maxDelay    = new Promise(res => setTimeout(res, MAX_DURATION));

  Promise.race([
    Promise.all([minDelay, pageLoaded]),
    maxDelay
  ]).then(() => playIntro());

  window.addEventListener('resize', () => { resizeCanvas(); buildTiles(); });

  // Retour via les flèches du navigateur (bfcache)
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      resizeCanvas();
      buildTiles();
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      canvas.style.pointerEvents = 'none';
      const m = new Promise(res => setTimeout(res, MIN_DURATION));
      const x = new Promise(res => setTimeout(res, MAX_DURATION));
      Promise.race([m, x]).then(() => playIntro());
    }
  });

})();
